import broker from '@utils/broker'

export const state = {
  
}

export const mutations = {

}

export const getters = {

}

export const actions = {

  insertData({ commit, dispatch, getters }, { url, body } = {}) {
    return broker.fetch.post(url, body)
    .then(res => {
      return res
    });
  },

  updateData({ commit, dispatch, getters }, { url, body } = {}) {
    return broker.fetch.patch(url, body)
    .then(res => {
      return res
    });
  },

  updateDataPost({ commit, dispatch, getters }, { url, body } = {}) {
    return broker.fetch.post(url, body)
    .then(res => {
      return res
    });
  },

  getData({ commit, dispatch, getters }, { url } = {}) {
    return broker.fetch.get(url)
    .then(res => {
      return res
    });
  },

  listData({ commit, dispatch, getters }, { url } = {}) {
    return broker.fetch.get(url)
    .then(res => {
      return res
    });
  },

  deleteData({ commit, dispatch, getters }, { url } = {}) {
    return broker.fetch.delete(url)
    .then(res => {
      return res
    });
  },

  cariData({ commit, dispatch, getters }, { url } = {}) {
    return broker.fetch.get(url)
    .then(res => {
      if (res.data.data){
        return res.data.data
      } else {
        return null
      }
      
    });
  },

  downloadData({ commit, dispatch, getters }, { url } = {}) {
    return broker.fetch.get(url, {responseType: 'blob'})
    .then(res => {
      return res
    });
  },


}


